/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsectioncategory3Inputs */

const en_placewebsectioncategory3 = /** @type {(inputs: Placewebsectioncategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const de_placewebsectioncategory3 = /** @type {(inputs: Placewebsectioncategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Placewebsectioncategory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsectioncategory3 = /** @type {((inputs?: Placewebsectioncategory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsectioncategory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsectioncategory3(inputs)
	return de_placewebsectioncategory3(inputs)
});
export { placewebsectioncategory3 as "placeWebSectionCategory" }